import { FC, useState } from 'react'
import useProgress from '@/hooks/useProcess'
import Image, { StaticImageData } from "next/legacy/image";
// import PointsIcon from '@/public/img/points/points-icon.svg'
import PointsJumpCoin from '@/public/img/points/jump-coin.webp'
// import { preloadEx } from "@/utils/preloader"

// const staticImageDataToAsset = (imageData: StaticImageData[] = []) => {
//   return imageData.map(({ src }) => {
//     return {
//       type: 'image',
//       src
//     }
//   })
// }

interface Props {
  current: number
}

const PointsLoading: FC<Props> = ({ current }) => {
  // const [webpLoaded, setWebpLoaded] = useState(false)
  const text = useProgress({ current })
  // preloadEx({
  //   assets: staticImageDataToAsset([PointsJumpCoin]),
  //   onProgress: (progress) => {
  //     if (progress === 1) {
  //       setWebpLoaded(true)
  //     }
  //   }
  // })
  return (
    <div className="w-full h-full flex items-center justify-center flex-col">
      {/* { webpLoaded ? (
        <div className="relative w-[180px] h-[180px]">
          <Image alt="jump-coin" src={PointsJumpCoin} layout="fill"/>
        </div>
      ) : <PointsIcon className="w-[81px] h-[92px]"/> } */}
      <div className="relative w-[180px] h-[180px]">
        <Image alt="jump-coin" src={PointsJumpCoin} layout="fill"/>
      </div>
      <p className="mt-[16px] font-bold text-[32px] text-[#fff] leading-[38px] tracking-[0.02em]">{ text }</p>
    </div>
  )
}

export default PointsLoading
